import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { grad } from '../components/ui';

const MENU: { section: string; rows: { icon: string; label: string; hint?: string }[] }[] = [
  {
    section: 'Learning',
    rows: [
      { icon: '📚', label: 'My Library' },
      { icon: '🔖', label: 'Bookmarked questions' },
      { icon: '⬇️', label: 'Downloads', hint: 'Offline' },
      { icon: '🎖️', label: 'My certificates' },
    ],
  },
  {
    section: 'Account',
    rows: [
      { icon: '🧾', label: 'Purchase history' },
      { icon: '🏷️', label: 'Coupons & offers', hint: '2 new' },
      { icon: '🔔', label: 'Notifications' },
      { icon: '❓', label: 'Help & support' },
    ],
  },
];

export function Profile() {
  const navigate = useNavigate();
  const { user, signOut, libraryProducts } = useApp();
  const initials = (user?.name ?? 'L').split(' ').map((s) => s[0]).slice(0, 2).join('').toUpperCase();

  function logout() {
    if (window.confirm('Log out of PulsePrep?')) {
      signOut();
      navigate('/login', { replace: true });
    }
  }

  return (
    <div style={{ paddingTop: 20 }}>
      <div className="hero" style={{ ...grad(['#5A2D9C', '#7C4DBE']), textAlign: 'center' }}>
        <div className="center" style={{ width: 84, height: 84, borderRadius: '50%', background: 'rgba(255,255,255,.22)', border: '3px solid rgba(255,255,255,.4)', fontSize: 30, fontWeight: 900, margin: '0 auto' }}>{initials}</div>
        <h1 style={{ fontSize: 22, fontWeight: 900, marginTop: 12 }}>{user?.name ?? 'Learner'}</h1>
        <p style={{ opacity: 0.9 }}>{user?.email ?? '—'}</p>
        {user?.phone && <p style={{ opacity: 0.75, fontSize: 13 }}>+91 {user.phone}</p>}
        <div className="row" style={{ background: 'rgba(255,255,255,.15)', borderRadius: 14, padding: '12px 0', marginTop: 16 }}>
          <Stat label="Owned" value={`${libraryProducts.length}`} />
          <Div />
          <Stat label="Hours" value="42" />
          <Div />
          <Stat label="Streak" value="7🔥" />
        </div>
      </div>

      {MENU.map((g) => (
        <section key={g.section} className="section">
          <div className="muted" style={{ fontWeight: 800, marginBottom: 8, marginLeft: 4 }}>{g.section}</div>
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {g.rows.map((r, i) => (
              <button
                key={r.label}
                onClick={() => {
                  if (r.label === 'My Library') navigate('/library');
                  else if (r.label === 'Bookmarked questions') navigate('/bookmarks');
                }}
                style={{ width: '100%', background: 'none', border: 'none', borderTop: i ? '1px solid var(--divider)' : 'none', display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', textAlign: 'left' }}
              >
                <span className="center" style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--primary-soft)', fontSize: 18 }}>{r.icon}</span>
                <span style={{ flex: 1, fontWeight: 600 }}>{r.label}</span>
                {r.hint && <span className="badge" style={{ background: 'var(--accent-soft)', color: 'var(--accent)' }}>{r.hint}</span>}
                <span className="faint">›</span>
              </button>
            ))}
          </div>
        </section>
      ))}

      <button className="btn btn-danger btn-block" style={{ marginTop: 22 }} onClick={logout}>Log out</button>
      <p className="faint" style={{ textAlign: 'center', fontSize: 12, marginTop: 14 }}>PulsePrep · v1.0.0 (web)</p>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ flex: 1, textAlign: 'center' }}>
      <div style={{ fontSize: 18, fontWeight: 900 }}>{value}</div>
      <div style={{ fontSize: 12, opacity: 0.9 }}>{label}</div>
    </div>
  );
}
function Div() {
  return <div style={{ width: 1, alignSelf: 'stretch', background: 'rgba(255,255,255,.25)' }} />;
}
